// import { useFlag } from '@unleash/proxy-client-react';

// import { unleashFeatureToggles } from 'configs';

type FeatureToggles = {
  dashboard: boolean;
  serviceInterruptions: boolean;
  // Add flags
  // ...
};

export const useFeatureToggles = (): FeatureToggles => {
  const dashboard = true; // useFlag(unleashFeatureToggles.PAGE_DASHBOARD);
  const serviceInterruptions = false; // useFlag(unleashFeatureToggles.PAGE_SERVICE_INTERRUPTIONS);

  return {
    dashboard,
    serviceInterruptions,
  };
};
